export function easeInOutQuint(t) {
  return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t
}

export { useTimeWheelDates as default } from "./useTimeWheelDates.1"
